export default "__VITE_ASSET__DK8WSOt3__"